export default function offerDropdownOptionsResolver({ offer, offerSettings, itemSettings, root }) {
    let animationName = 'fade';

    if (itemSettings.animation) {
        animationName = itemSettings.animation;
    } else if (itemSettings.animation === null) {
        animationName = '';
    }

    return {
        bind: {
            offer: {
                default: () => offer,
            },
            root: {
                default: () => root,
            },
            mobile: {
                default: offerSettings.mobile,
            },
            isShowDropdownChange: {
                default: () => offerSettings.isShowDropdown,
            },
            animation: {
                default: animationName,
            },
        },
    };
}
